module.exports = __webpack_public_path__ + "img/wave-3.be64efa6.svg";